import { useState } from 'react';
import './PainPoints.css';

const points = [
  {
    num: '01',
    problem: 'No Website Or An Outdated One',
    problemDesc: 'Customers search you up and find nothing — or a site that looks 10 years old.',
    solution: 'Fast, modern, mobile-first websites built to convert visitors into customers.',
  },
  {
    num: '02',
    problem: 'Zero Visibility On Google',
    problemDesc: 'Your competitors show up first, every single time someone searches your service.',
    solution: 'SEO and Google Ads groundwork that puts you in front of ready-to-buy customers.',
  },
  {
    num: '03',
    problem: 'Social Media Feels Random',
    problemDesc: 'Posting sometimes, no strategy, no growth in followers or actual enquiries.',
    solution: 'A consistent content calendar and ad strategy across Instagram, Facebook & Meta.',
  },
  {
    num: '04',
    problem: 'Leads Go Cold, No Follow-Up',
    problemDesc: 'Enquiries come in on WhatsApp and calls, then quietly disappear into the gap.',
    solution: 'WhatsApp automation and CRM flows that follow up before the lead goes cold.',
  },
  {
    num: '05',
    problem: 'Brand Looks Inconsistent',
    problemDesc: 'Different logo styles, colors, and tone across your shop board, site, and socials.',
    solution: 'A complete brand identity system — logo, colors, and creatives — used everywhere.',
  },
];

export default function PainPoints() {
  const [active, setActive] = useState(0);

  return (
    <section id="pain-points" className="pp-section">
      <div className="pp-header">
        <span className="section-label reveal">Pain Points → Solutions</span>
        <h2 className="section-title reveal">Every business problem. <em>One fix.</em></h2>
        <p className="section-sub reveal">
          We've seen the same growth blockers across Trichy businesses — here's how AerialRoot solves each one.
        </p>
        <div className="pp-counter reveal">
          <span className="pp-counter-label">Issues solved</span>
          <span className="pp-counter-num">{active + 1} / {points.length}</span>
        </div>
      </div>

      <div className="pp-body reveal">
        <div className="pp-list">
          {points.map((p, i) => (
            <button
              key={p.num}
              className={`pp-item ${active === i ? 'active' : ''}`}
              onClick={() => setActive(i)}
              type="button"
            >
              <span className="pp-num">{p.num}</span>
              <span className="pp-problem">{p.problem}</span>
              <span className="pp-arrow">→</span>
            </button>
          ))}
        </div>

        <div className="pp-detail" key={active}>
          <span className="pp-detail-tag">Problem</span>
          <h4>{points[active].problem}</h4>
          <p className="pp-detail-problem">{points[active].problemDesc}</p>
          <span className="pp-detail-tag pp-fix-tag">AerialRoot Fix</span>
          <p className="pp-detail-fix">{points[active].solution}</p>
        </div>
      </div>
    </section>
  );
}
